import { ReactNode } from 'react'
import { STAGGER_MS } from './rules-activity-chart'

/** Where item `index` of a group of `count` falls inside one sweep, in ms. The sweep
 *  takes STAGGER_MS end to end however many items are in it, off the same constant
 *  the chart and the Details rail use. */
export const swapDelay = (index: number, count: number): number =>
	count > 1 ? (STAGGER_MS * index) / (count - 1) : 0

interface SwapValueProps {
	/** The figure this wraps: a new token replays the animation. Deliberately NOT the
	 *  time frame — a rule with the same count in both windows has not changed. */
	token: string | number
	children: ReactNode
	className?: string
	/** Milliseconds to hold before this value arrives — a position in the group, spread
	 *  over `STAGGER_MS`. For a list you read down, not for a row of tiles read across,
	 *  where a stagger is only lag on the last tile. */
	delay?: number
}

/**
 * Replays a short fade-and-rise whenever the value inside it changes, so it is
 * visible which numbers answered a 30/7 switch or a Refresh.
 *
 * A key remount, not a CSS transition: `opacity` and `transform` have nothing to
 * interpolate from when only the text changed, and replaying via a class needs a
 * forced reflow. The key is the token itself, so a value that returns to an earlier
 * one still remounts.
 */
export const SwapValue = ({
	token,
	children,
	className,
	delay
}: SwapValueProps) => (
	<span
		key={String(token)}
		className={`custom-rules-swap-value${className ? ` ${className}` : ''}`}
		style={delay ? { animationDelay: `${Math.round(delay)}ms` } : undefined}
	>
		{children}
	</span>
)
